import { render, staticRenderFns } from "./AvatarEdit.vue?vue&type=template&id=2d58bac4&scoped=true"
import script from "./AvatarEdit.vue?vue&type=script&lang=js"
export * from "./AvatarEdit.vue?vue&type=script&lang=js"
import style0 from "./AvatarEdit.vue?vue&type=style&index=0&id=2d58bac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d58bac4",
  null
  
)

export default component.exports